import React from 'react'
import { Form, Input, Select, InputNumber, Button ,Row,Col} from 'antd';



const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not validate email!',
    number: '${label} is not a validate number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

const LogRequest = () => {
    const [form] = Form.useForm();
const { Option } = Select;
  const onFinish = values => {
    console.log(values);
  };

  const onGenderChange = value => {
    switch (value) {
      case "male":
        form.setFieldsValue({ note: "Hi, man!" });
        return;
      case "female":
        form.setFieldsValue({ note: "Hi, lady!" });
        return;
      case "other":
        form.setFieldsValue({ note: "Hi there!" });
        return;
        default :
        return null
    }
  };

  return (
      <>
      <Row>
          <Col span="12" md={12}>
          <Form {...layout} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>
      <Form.Item
        name={['user', 'name']}
        label="Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={['user', 'email']}
        label="Email"
        rules={[
          {
            type: 'email',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={['user', 'regNo']}
        label="RegNo"
        rules={[
          {
            type: 'number',
            min: 0,
            max: 5,
          },
        ]}
      >
        <InputNumber />
      </Form.Item>
      <Form.Item name="category" label="category" rules={[{ required: true }]}>
        <Select
          placeholder="Select a option and change input text above"
          onChange={onGenderChange}
          allowClear
        >
          <Option value="Fee Mangement">Fee Related issues</Option>
          <Option value="Acedemics">Academics</Option>
          <Option value="other">other</Option>
        </Select>
      </Form.Item>
      <Form.Item name={['user', 'website']} label="Website">
        <Input />
      </Form.Item>
      <Form.Item name={['user', 'message']} label="message">
        <Input.TextArea />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
 
          </Col>
      </Row>
      </>

 );
};

export default LogRequest